import React from 'react'
import { Link } from 'react-router-dom'
import Layout from '../component/Layout/Layout'
import { useNewHomeAPI } from '../hooks/useAllCategoryData';

export default function TheWomenOfChaashni() {
   const { isLoading, error, data } = useNewHomeAPI();
    if (error) return <div>{error.message}</div>;
  return (
    <Layout title="The Women of Chaashni: Chaashni Couture" description="Chaashni Couture: The Women of Chaashni" >
    <div className="site-content-wrap static-page">
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <h1 className="sustom-heading-h1">The Women of Chaashni</h1>
          <div className="content-box">
            <div  className="people-of-chaashni women-of-Chaashni">
              <ul>
                {data?.womenofchaashni && (
                  <>
                  {[...data.womenofchaashni]
                    .sort(() => 0.5 - Math.random()) // Randomize order
                    .map((src, index) => (
                      <li key={index}>
                        <img src={`${process.env.REACT_APP_API_ROOT}/storage/app/public/womenofchaashni/${src.desktop}`} alt={src.desktop} />
                      </li>
                  ))}
                  </>
                )}
              </ul>
            </div>
          </div>
          <div class="content-box">
  <div class="people-of-chaashni women-of-Chaashni">
    <ul>
    <li><img src="http://hemant/chaashnicouture/storage/app/public/womenofchaashni/img8.jpg" alt="img8.jpg"/></li>
    <li><img src="http://hemant/chaashnicouture/storage/app/public/womenofchaashni/img.jpg" alt="img.jpg"/></li>
    <li><img src="http://hemant/chaashnicouture/storage/app/public/womenofchaashni/img2.jpg" alt="img2.jpg"/></li>
    <li><img src="http://hemant/chaashnicouture/storage/app/public/womenofchaashni/img3.jpg" alt="img3.jpg"/></li>
    <li><img src="http://hemant/chaashnicouture/storage/app/public/womenofchaashni/img4.jpg" alt="img4.jpg"/></li>
    <li><img src="http://hemant/chaashnicouture/storage/app/public/womenofchaashni/img5.jpg" alt="img5.jpg"/></li>
    <li><img src="http://hemant/chaashnicouture/storage/app/public/womenofchaashni/img7.jpg" alt="img7.jpg"/></li>
    <li><img src="http://hemant/chaashnicouture/storage/app/public/womenofchaashni/img9.jpg" alt="img9.jpg"/></li>
    <li><img src="http://hemant/chaashnicouture/storage/app/public/womenofchaashni/img10.jpg" alt="img10.jpg"/></li>
      
      
      
      {/* <li><img src="http://hemant/chaashnicouture/storage/app/public/womenofchaashni/img6.jpg" alt="img6.jpg"/></li>
      <li><img src="http://hemant/chaashnicouture/storage/app/public/womenofchaashni/img8.jpg" alt="img8.jpg"/></li>
      <li><img src="http://hemant/chaashnicouture/storage/app/public/womenofchaashni/img7.jpg" alt="img7.jpg"/></li> */}
    </ul>
  </div>
</div>
        </div>
      </div>
    </div>
  </div>
  </Layout>
  )
}
